import React from 'react';
import HeadingDescription from '../HeadingDescription';
import TechnicalDataTable from '../TechnicalDataTable';
import ProposalImageWithCaption from '../ProposalImageWithCaption';
import manual_gun_full_1 from '../../assets/proposalImages/manual_gun_full_1.png';
import gema_app from '../../assets/proposalImages/gema_app.png';
import injector from '../../assets/proposalImages/injector.png';
import gun_control from '../../assets/proposalImages/gun_control.png';


export default function GemaManualGunSection({ manualGunSpec }) {
  const ts = manualGunSpec || {};

  return (
    <>
      <div className="a4-paddings quotation-page quotation-page-compact">
        <div className="quotation-page-inner quotation-bg-light">
          <div className="quotation-no-break" style={{ marginBottom: 16 }}>
            <h2 style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 18, fontWeight: 700, color: '#000814', margin: '0 0 4px 0' }}>
              Gema Manual Gun
            </h2>
            <div className="quotation-yellow-divider" />
          </div>
          <div className="quotation-section-block">
            <HeadingDescription heading="GEMA Manual Powder Coating Gun (OptiFlex - Pro)" description="" level={3} />
          </div>

          <ProposalImageWithCaption
            src={manual_gun_full_1}
            title="Manual Gun - OptiFlex Pro"
            containerStyle={{ marginBottom: 30 }}
            imgStyle={{ width: '75%' }}
          />

          <div style={{ display: 'flex', justifyContent: 'center', gap: 24, marginBottom: 30, flexWrap: 'wrap' }}>
            <ProposalImageWithCaption
              src={gun_control}
              title="OptiStar 4.0 CG20 Gun Control"
              containerStyle={{ flex: 1, minWidth: 200 }}
              wrapperStyle={{ marginBottom: 0 }}
              imgStyle={{ width: '75%' }}
            />
            <ProposalImageWithCaption
              src={injector}
              title="OptiFlow IG07 injector"
              containerStyle={{ flex: 1, minWidth: 200 }}
              wrapperStyle={{ marginBottom: 0 }}
              imgStyle={{ width: '50%' }}
            />
          </div>

          <ProposalImageWithCaption
            src={gema_app}
            title="GEMA App (Control and monitoring of the gun parameters through the app)"
            containerStyle={{ marginBottom: 30 }}
            imgStyle={{ borderRadius: 18, width: '57%' }}
          />
        </div>
      </div>

      <div className="a4-paddings quotation-page quotation-page-compact">
        <div className="quotation-page-inner quotation-bg-light">
          {ts?.electrical_data && (
            <TechnicalDataTable
              data={ts.electrical_data.data}
              headers={ts.electrical_data.headers}
              title="Electrical Data"
            />
          )}
          {ts?.pneumatical_data && (
            <TechnicalDataTable
              data={ts.pneumatical_data.data}
              headers={ts.pneumatical_data.headers}
              title="Pneumatical Data"
            />
          )}
          {ts?.application_data && (
            <TechnicalDataTable data={ts.application_data.data} headers={ts.application_data.headers} title="Application data" />
          )}
          {ts?.operating_conditions && (
            <>
              <TechnicalDataTable
                data={Array.isArray(ts.operating_conditions.data?.[0]) ? ts.operating_conditions.data[0] : ts.operating_conditions.data}
                title="Operating conditions"
              />
              {ts.operating_conditions.disclaimers && (
                <p style={{ fontSize: 12, color: '#666', marginTop: 8 }}>{ts.operating_conditions.disclaimers.join(' ')}</p>
              )}
            </>
          )}
          <p style={{ fontSize: 12, marginTop: 16 }}><strong>STAND ALONE UNIT MANUAL GUN:</strong> 1 Gun - 1 NOS, 1 Control Unit - 1 NOS, 1 Trolley & Hopper - 1 NOS</p>
          <p style={{ fontSize: 12, marginTop: 8 }}><strong>SCOPE OF SUPPLY - STAND ALONE UNIT:</strong> Gema Manual Powder Coating Unit Model OptiFlex-Pro (as per scope table)</p>
        </div>
      </div>
    </>
  );
}
